// extracted by css-extract-rspack-plugin
export default {"root":"root-n0CRWD","credentials":"credentials-bvUmVH","name":"name-nDajBq","email":"email-gXt7oP","avatarPlaceholder":"avatarPlaceholder-F9vLoy"};